import React, { memo } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Typography,
  List,
  ListItemButton,
  ListItemText,
} from '@mui/material';

const TranslationSidebar = memo(
  ({ languages, selectedLanguage, onSelectLanguage }) => (
    <Box
      sx={{
        width: 220,
        borderRight: 1,
        borderColor: 'divider',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        bgcolor: 'background.paper',
      }}
    >
      <Box
        sx={{
          px: 1.5,
          py: 1,
          borderBottom: 1,
          borderColor: 'divider',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 0.5,
        }}
      >
        <Typography variant="subtitle2" noWrap>
          Languages
        </Typography>
      </Box>

      <Box sx={{ flex: 1, overflow: 'auto' }}>
        <List dense disablePadding>
          {languages.map((lang) => (
            <ListItemButton
              key={lang.value}
              selected={selectedLanguage === lang.value}
              onClick={() => onSelectLanguage(lang.value)}
              sx={{
                py: 0.75,
                borderLeft: 3,
                borderColor:
                  selectedLanguage === lang.value
                    ? 'primary.main'
                    : 'transparent',
              }}
            >
              <ListItemText
                primary={lang.label}
                primaryTypographyProps={{
                  variant: 'body2',
                  fontSize: '0.8rem',
                }}
              />
            </ListItemButton>
          ))}
        </List>
      </Box>
    </Box>
  )
);

TranslationSidebar.propTypes = {
  languages: PropTypes.array.isRequired,
  selectedLanguage: PropTypes.string.isRequired,
  onSelectLanguage: PropTypes.func.isRequired,
};

export default TranslationSidebar;
